/**
 * 复用 BoMate 客户端原始字标；由页面主题切换明暗版本，避免每条消息各建主题监听器。
 * @param className 字标尺寸与布局，默认采用客户端执行过程头部的 68 × 18 像素。
 */
export default function BomateWordmark({ className = 'h-[18px] w-[68px]' }: { className?: string }) {
  const src = `${import.meta.env.BASE_URL}bomate-sidebar-lockup.svg?v=wordmark-theme-v2`;
  return <span role="img" aria-label="BoMate" className={`inline-flex shrink-0 ${className}`}>
    <img src={src} alt="" draggable={false} className="h-full w-full object-contain object-left dark:hidden" />
    <img src={`${src}#dark-theme`} alt="" draggable={false} className="hidden h-full w-full object-contain object-left dark:block" />
  </span>;
}
